import { render, staticRenderFns } from "./OrderCertification.vue?vue&type=template&id=6e9b8e6e&"
import script from "./OrderCertification.vue?vue&type=script&lang=js&"
export * from "./OrderCertification.vue?vue&type=script&lang=js&"
import style0 from "./OrderCertification.vue?vue&type=style&index=0&id=6e9b8e6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports